export default __webpack_public_path__ + "static/media/44t.112dbd3f.jpg";